<template>
  <b-table
    id="PhysicalProductAdjustmentStockTable"
    ref="PhysicalProductAdjustmentStockTable"
    small
    fixed
    sort-icon-left
    head-variant="light"
    :items="items"
    :fields="fields"
    :filter="filter"
    :filter-included-fields="[
      'productNoAndName',
      'productCode',
      'productNameMain',
    ]"
  >
    <template v-slot:cell(index)="row">
      <div class="d-flex align-items-center justify-content-center">
        {{ row.index + 1 }}.
      </div>
    </template>

    <template v-slot:cell(image)="row">
      <ProductImage :src="row.item.imageUrl || null" />
    </template>

    <template v-slot:cell(currentStockToAfterAdjustment)="row">
      <PreAndPostStockField
        inputMaxWidth="188px"
        :currentStock="convertUnitStock(row)"
        :adjustStock="row.item.adjustmentAmount"
        :afterStockValue="row.item.currentStockToAfterAdjustment"
        :showPreStock="false"
        :onChange="value => onChangeAdjustPhysicalStock(row, value)"
      />
    </template>
  </b-table>
</template>

<script>
import BigNumber from "bignumber.js";
import PreAndPostStockField from "@/components/table/stock/fields/PreAndPostStockField.vue";
import ProductImage from "@/components/table/stock/component/ProductImage.vue";

export default {
  name: "PhysicalProductAdjustmentStockTable",
  components: { PreAndPostStockField, ProductImage },
  props: {
    items: {
      type: Array,
      required: true,
    },
    filter: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      MAX_VALUE: 9999999999.99,
      MIN_VALUE: -9999999999.99,
      fields: [
        {
          key: "index",
          label: "",
          class: "text-center",
          thStyle: { width: "4%" },
          tdStyle: { width: "4%" },
        },
        {
          key: "image",
          label: "",
          thStyle: { width: "5%" },
          tdStyle: { width: "5%" },
        },
        {
          key: "productNoAndName",
          label: "รหัสสินค้า - ชื่อสินค้า",
          thStyle: { width: "56%" },
          tdStyle: { width: "56%" },
        },
        {
          key: "currentStockToAfterAdjustment",
          label: "สต๊อกหลังปรับปรุง",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: { width: "20%" },
          tdStyle: { width: "20%" },
        },
        {
          key: "productUnit",
          label: "หน่วยสินค้า",
          thStyle: { width: "15%" },
          tdStyle: { width: "15%" },
          tdClass: "text-wrap-cell",
        },
      ],
    };
  },
  methods: {
    convertUnitStock(row) {
      return row.item.productAvailableStock;
    },
    onChangeAdjustPhysicalStock(row, value) {
      const num = Number(value);
      this.$set(row.item, "adjustmentAmount", num);
      const current = Number(row.item.productAvailableStock) || 0;
      const afterAdjustment = new BigNumber(current).plus(num).toFixed(2);
      this.$set(row.item, "currentStockToAfterAdjustment", afterAdjustment);
    },
    validateAndNormalizeItems() {
      const maxBN = new BigNumber(this.MAX_VALUE);
      const minBN = new BigNumber(this.MIN_VALUE);

      this.items.forEach(item => {
        if (item.adjustmentAmount != null) {
          let adjustmentAmount = new BigNumber(item.adjustmentAmount);

          // Clamp adjustment amount to valid range
          if (adjustmentAmount.isGreaterThan(maxBN)) {
            adjustmentAmount = maxBN;
          } else if (adjustmentAmount.isLessThan(minBN)) {
            adjustmentAmount = minBN;
          }

          // Round to 2 decimal places
          adjustmentAmount = adjustmentAmount.decimalPlaces(
            2,
            BigNumber.ROUND_DOWN
          );

          // Update the item if value changed
          const currentAdjustment = new BigNumber(item.adjustmentAmount);
          if (!adjustmentAmount.isEqualTo(currentAdjustment)) {
            this.$set(item, "adjustmentAmount", adjustmentAmount.toNumber());
          }
        }

        // Also validate currentStockToAfterAdjustment if it exists
        if (item.currentStockToAfterAdjustment != null) {
          let afterValue = new BigNumber(item.currentStockToAfterAdjustment);

          // Clamp to valid range
          if (afterValue.isGreaterThan(maxBN)) {
            afterValue = maxBN;
          } else if (afterValue.isLessThan(minBN)) {
            afterValue = minBN;
          }

          // Round to 2 decimal places
          afterValue = afterValue.decimalPlaces(2, BigNumber.ROUND_DOWN);

          // Update if value changed
          const currentAfterValue = new BigNumber(
            item.currentStockToAfterAdjustment
          );
          if (!afterValue.isEqualTo(currentAfterValue)) {
            this.$set(
              item,
              "currentStockToAfterAdjustment",
              afterValue.toFixed(2)
            );
          }
        }
      });
    },
  },
  mounted() {
    // Validate items on mount (when imported data is loaded)
    this.$nextTick(() => {
      this.validateAndNormalizeItems();
    });
  },
  watch: {
    items: {
      handler() {
        this.$nextTick(() => {
          this.validateAndNormalizeItems();
        });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
